import { GET_MEMBER_LOGIN_REQUEST, GET_MEMBER_LOGIN_SUCCESS } from "./type";

const initialState = {
    loginUser: null,
    error: null,
    loading: false,
};

const MemberLoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MEMBER_LOGIN_REQUEST:
            return {
                ...state,
                loginUser: null,
                loading: false,
                error: null,
            };
        case GET_MEMBER_LOGIN_SUCCESS:
            return {
                ...state,
                loginUser: action.payload,
                loading: false,
                error: null,
            };
        default:
            return state;
    }
};

export default MemberLoginReducer;
